import ApiConfig from "../../../config/api-config";
import { $apiClientForm } from "../../../utils/apiClient";

export function postEditGodo(payload) {
  const idValue = payload.get('id');
  return $apiClientForm.post(`${ApiConfig.EDITGODO}`+ idValue , payload);
}
